export const STORE_CATEGORY_PICKUP = 0
export const STORE_CATEGORY_GIVING = 1
export const STORE_CATEGORY_ORGA = 2

export const STORE_CATEGORIES = [STORE_CATEGORY_PICKUP, STORE_CATEGORY_GIVING, STORE_CATEGORY_ORGA]

export default {
  PICKUP: STORE_CATEGORY_PICKUP,
  GIVING: STORE_CATEGORY_GIVING,
  ORGA: STORE_CATEGORY_ORGA,
  ALL: STORE_CATEGORIES,
}
